import { motion } from "framer-motion";
import { Phone } from "lucide-react";

export const Header = () => {
  return (
    <motion.header
      initial={{ y: -40, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.9, ease: [0.16, 1, 0.3, 1] }}
      className="fixed top-0 left-0 right-0 z-50 backdrop-blur-xl bg-cream/85 border-b border-ink/10"
      data-testid="site-header"
    >
      <div className="max-w-[1180px] mx-auto px-6 md:px-10 h-[72px] flex items-center justify-between">
        <a href="/" className="flex items-baseline gap-2" data-testid="logo-link">
          <span className="font-serif text-[23px] tracking-tight text-ink">Columbus</span>
          <span className="font-mono text-[10px] tracking-[0.3em] uppercase text-gold mt-0.5">Home Options</span>
        </a>
        <div className="flex items-center gap-6">
          <a
            href="tel:+14709088726"
            data-testid="phone-link"
            className="hidden sm:flex items-center gap-2 font-mono text-[13px] tracking-wider text-ink-soft hover:text-gold transition-colors duration-300"
          >
            <Phone size={13} /> (470) 908-8726
          </a>
          <a
            href="#start"
            data-testid="header-cta"
            className="font-mono text-[11px] tracking-[0.15em] uppercase px-5 py-2.5 bg-evergreen text-cream hover:bg-gold transition-colors duration-300"
          >
            Get Started
          </a>
        </div>
      </div>
    </motion.header>
  );
};
